/** Workspace plan reads survive route navigation, but never account/workspace changes. */
import AuthController from './AuthController.js';
import { sessionFetch, sessionGeneration } from '../core/navGeneration.js';

const apiBase = () => AuthController.getConfig?.().BASE_URL || '';
let cached = null;
let cachedKey = null;

export function planContextKey() {
  if (!AuthController.isAuthenticated() || !AuthController.getActiveOrg()?.guid) return null;
  return JSON.stringify([AuthController.getEntity()?.guid, AuthController.getActiveOrg().guid,
    AuthController.getStoredActiveOrg(), apiBase(), sessionGeneration()]);
}

export function fetchMyPlan() {
  const key = planContextKey();
  if (!key) { cached = null; cachedKey = null; return Promise.resolve(null); }
  if (cached && cachedKey === key) return cached;
  cachedKey = key;
  const request = (async () => {
    try {
      // This is shell data. A route-bound request can remain pending forever
      // during sign-in navigation; fence the response by workspace instead.
      const res = await sessionFetch(`${apiBase()}/m5t/v5/billing/usage`);
      if (!res.ok) return null;
      const data = await res.json();
      return planContextKey() === key && data?.ok ? data : null;
    } catch { return null; }
  })();
  cached = request;
  request.then(data => { if (!data && cached === request) cached = null; });
  return request;
}

/** True unless the plan EXPLICITLY lacks the feature (null data = allowed). */
export async function planAllowsClient(feature) {
  const data = await fetchMyPlan();
  if (!data?.plan?.features) return true;
  return data.plan.features[feature] !== false;
}

/** The over-quota banner state, or null. */
export async function quotaState() {
  const data = await fetchMyPlan();
  return data?.quota || null;
}
